<template>
  <div class="min-h-screen relative bg-black text-white grid md:grid-cols-2">
    <!-- Imagem lateral no desktop -->
    <div class="hidden md:flex items-center justify-center relative">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background"
        class="absolute inset-0 w-full h-full object-cover"
      />
      <div class="z-10 text-center">
        <h1 class="text-8xl font-bold text-white drop-shadow-lg">Cash</h1>
        <h2
          class="text-4xl font-semibold text-orange-500 tracking-widest mt-2 drop-shadow-lg"
        >
          BROKER
        </h2>
      </div>
    </div>

    <div class="fixed inset-0 z-0 md:hidden">
      <img
        src="/cashbroker-bg.png"
        alt="Cash Broker Background Mobile"
        class="w-full h-full object-cover"
      />
    </div>

    <!-- Card de recuperação -->
    <div
      class="flex items-center justify-center p-6 md:bg-[#0f0f0f] relative z-10"
    >
      <div
        class="w-full max-w-md bg-[#1a1a1a] border border-gray-700 p-8 rounded-xl shadow-md"
      >
        <!-- Logo -->
        <div class="flex items-center justify-center gap-4 mb-8">
          <img src="/image/logo.png" alt="Logo" class="h-16 w-auto" />
          <div class="leading-tight">
            <h1 class="text-white text-3xl font-bold">Cash</h1>
            <h2 class="text-orange-500 text-xl font-semibold tracking-widest">
              BROKER
            </h2>
          </div>
        </div>

        <!-- Título -->
        <h2 class="text-white text-xl font-semibold text-center mb-6">
          Recuperar Senha
        </h2>

        <!-- Formulário -->
        <form class="space-y-4" @submit.prevent="handleForgot">
          <div>
            <label class="text-sm text-gray-300 block mb-1">E-mail</label>
            <input
              v-model="email"
              type="email"
              placeholder="seu@email.com"
              class="w-full px-4 py-3 rounded-md bg-black/60 text-white placeholder-gray-500 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>

          <button
            type="submit"
            class="w-full py-3 mt-2 rounded-md bg-gradient-to-r from-orange-600 to-red-600 hover:opacity-90 transition font-semibold"
          >
            <span v-if="isLoading">Enviando...</span>
            <span v-else>Enviar código</span>
          </button>

          <p v-if="error" class="text-red-400 text-sm text-center mt-2">
            {{ error }}
          </p>
        </form>

        <!-- Link para login -->
        <div class="text-center mt-6">
          <RouterLink
            to="/auth/login"
            class="text-sm text-gray-400 hover:text-orange-400 transition"
          >
            Lembrou sua senha? <span class="underline">Entrar</span>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";

const email = ref("");
const isLoading = ref(false);
const error = ref("");
const router = useRouter();

const handleForgot = async () => {
  if (!email.value) {
    error.value = "Informe seu e-mail.";
    return;
  }

  isLoading.value = true;
  error.value = "";

  try {
    // await axios.post("/api/password/forgot", { email: email.value });
    router.push({ path: "/auth/verify-code", query: { email: email.value } });
  } catch (err: any) {
    error.value = err.response?.data?.message || "Erro ao enviar código.";
  } finally {
    isLoading.value = false;
  }
};
</script>
